const updatesData = [
  {
    date: '2026-07-30',
    title: '香蕉视频本周新增片源突破300部，高清占比达95%',
    tag: '更新',
  },
  {
    date: '2026-07-28',
    title: '红桃视频原创系列《都市夜话》第三季正式上线',
    tag: '首发',
  },
  {
    date: '2026-07-26',
    title: '蜜桃视频完成播放器重大升级，低带宽下流畅度提升40%',
    tag: '技术',
  },
  {
    date: '2026-07-24',
    title: '91视频社区互动功能改版，新增评分与收藏体系',
    tag: '功能',
  },
  {
    date: '2026-07-22',
    title: '樱花视频月活跃用户突破500万，增速领跑行业',
    tag: '数据',
  },
  {
    date: '2026-07-20',
    title: '糖豆视频上线专题分类功能，内容发现效率大幅提升',
    tag: '功能',
  },
  {
    date: '2026-07-18',
    title: '青青草视频新接入两家合作平台，聚合阵容持续扩大',
    tag: '平台',
  },
  {
    date: '2026-07-15',
    title: '樱桃视频推出会员专属高清频道，4K画质全面开放',
    tag: '品质',
  },
  {
    date: '2026-07-12',
    title: '行业观察：暑期观影高峰来临，各平台内容储备量同比增35%',
    tag: '行业',
  },
];

export default function Updates() {
  return (
    <section id="updates" className="bg-background-50 section-padding">
      <div className="section-container">
        <div className="text-center mb-10">
          <span className="inline-block px-3 py-1 rounded-full bg-secondary-100 text-secondary-700 text-xs font-medium mb-3">
            实时动态
          </span>
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
            最新动态
          </h2>
          <p className="text-sm text-foreground-500 max-w-lg mx-auto">
            影视平台行业一手快讯，聚合各平台最新更新、功能发布与运营动态
          </p>
        </div>

        <div className="max-w-3xl mx-auto">
          <div className="relative pl-8 border-l-2 border-background-200">
            {updatesData.map((item, idx) => (
              <div key={idx} className="relative mb-8 last:mb-0">
                <div className="absolute -left-[33px] w-4 h-4 rounded-full bg-background-50 border-2 border-primary-400"></div>
                <div className="bg-background-50 rounded-xl border border-background-200/70 p-4 hover:border-primary-200 transition-all duration-300 cursor-pointer">
                  <div className="flex items-center gap-2 mb-1.5">
                    <span className="text-xs text-foreground-400">{item.date}</span>
                    <span className={`inline-block px-2 py-0.5 rounded-full text-[10px] font-medium ${
                      item.tag === '首发' ? 'bg-primary-100 text-primary-700' :
                      item.tag === '更新' ? 'bg-accent-100 text-accent-700' :
                      item.tag === '技术' ? 'bg-secondary-100 text-secondary-700' :
                      item.tag === '数据' ? 'bg-primary-100 text-primary-700' :
                      item.tag === '行业' ? 'bg-accent-100 text-accent-700' :
                      'bg-secondary-100 text-secondary-700'
                    }`}>
                      {item.tag}
                    </span>
                  </div>
                  <h3 className="text-sm md:text-base font-medium text-foreground-800 leading-relaxed">
                    {item.title}
                  </h3>
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="text-center mt-8">
          <a
            href="#index"
            className="inline-flex items-center gap-2 text-sm text-primary-600 hover:text-primary-700 font-medium cursor-pointer"
          >
            查看更多动态
            <i className="ri-arrow-right-line"></i>
          </a>
        </div>
      </div>
    </section>
  );
}